import {Component, Inject, OnInit, Sanitizer, ViewEncapsulation} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from "@angular/material";
import {ApiService} from "../../../service/api";
import {PayPalDialog} from "../../../components/checkout/dialog/paypal/paypal.component";
import {AdvanceDialog} from "../../../components/checkout/dialog/advance/advance.component";
import {CartService} from "../../../service/cart";
import {DomSanitizer} from "@angular/platform-browser";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'purchase-detail',
    templateUrl: './detail.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit {

    public row: any;
    public items: any;

    constructor(public api: ApiService,
                public cart: CartService,
                public dialog: MatDialog,
                public route: ActivatedRoute,
                public sanitizer: Sanitizer,
                public domsanitizer: DomSanitizer,
                public dialogRef: MatDialogRef<DetailComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.row = data.row;
        this.items = this.row.positions;
    }

    setRow(row) {
        this.row = row;
        this.items = row.positions;
    }

    getTotal(row): number {
        var total = 0.0;
        if (row.carttotal)
            total += parseFloat(row.carttotal)

        if (row.shipmentfee)
            total += parseFloat(row.shipmentfee)

        if (row.purchasefee)
            total += parseFloat(row.purchasefee)

        return total;
    }

    getColors(item): any[] {
        try {
            let c = JSON.parse(item.customization);
            if (c && c.colors) {
                return c.colors;
            }
        } catch (ex) {
            return [];
        }
    }

    ngOnInit() {
    }

    pay(method): void {
        let total = Math.round((this.row.total) * 100) / 100;
        if (method == 'paypal') {
            this.dialog.open(PayPalDialog, {
                data: {
                    payment: this.row.payment,
                    total: {
                        subtotal: total,
                        shipping: 0,
                        handling_fee: 0,
                        total: total
                    },
                    purchase: this.row
                }
            });
        } else if (method == 'advance') {
            this.dialog.open(AdvanceDialog, {
                data: {
                    payment: this.row.payment,
                    total: {
                        subtotal: total,
                        shipping: 0,
                        handling_fee: 0,
                        total: total
                    },
                    purchase: this.row
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/orders/detail/detail.component.ts